<template>
    <component :is="id" v-if="hasComponent"></component>
</template>
<script>
    let components = {
        'bank': () => import('./key-bank/index'),
        'cinema': () => import('./key-cinema/index'),
        'emails': () => import('./key-emails/index'),
        'gifts': () => import('./key-gifts/index'),
        'tours': () => import('./key-tours/index'),
        'inventory': () => import('./key-inventory/index')
    }
    export default {
        props: {
            id: String
        },
        components: {
            ...components
        },
        computed: {
            hasComponent () {
                return !!components[this.id]
            }
        }
    }
</script>
